import { Component, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AppRootService, ICheckRightUse, IGlobalAppConfig } from '../../services/app-root/app-root-service';
import { IconDefinition, IconName } from "@fortawesome/free-regular-svg-icons";
import { faBars, faChevronDown, faChevronUp, faHome } from "@fortawesome/free-solid-svg-icons";
import { findIconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Yii } from 'libraries/interfaces/Yii';
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { CONFIG_HOME, IHomeConfig } from "app_home/home-domain.service";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { wenji } from 'libraries/interfaces/IWenji';
import { DropdownComponent } from "libraries/ui_dropdown/dropdown.component";


@Component({
    selector: 'app-nav',
    template: `
        <dropdown #dropdown
                  class="app-nav-menu-container"
                  [togglerIcon]="togglerIcon"
                  (onToggle)="setMenu()">
            <div class="dropdown-content">
                <a class="navigation-item"
                   [routerLink]="'/home'"
                   (click)="closeMenu()">
                    <fa-icon [icon]="iconHome"></fa-icon>
                    {{homeName}}
                </a>
                <ng-container *ngFor="let applicationConfig of appConfigurationsValues">
                    <a class="navigation-item"
                       *ngIf="!hasSubMenu(applicationConfig) && applicationConfig.name"
                       (click)="closeMenu()"
                       [routerLink]="applicationConfig.routerLink">
                        <fa-icon *ngIf="applicationConfig.icon"
                                 [icon]="applicationConfig.icon | iconNameToDefinition"></fa-icon>
                        {{applicationConfig.name}}
                    </a>
                    <div class="navigation-item" *ngIf="hasSubMenu(applicationConfig)">
                        <a [routerLink]="applicationConfig.routerLink" (click)="closeMenu()">
                            <fa-icon *ngIf="applicationConfig.icon"
                                     [icon]="applicationConfig.icon | iconNameToDefinition"></fa-icon>
                            {{applicationConfig.name}}
                        </a>
                        <fa-icon class="sub-menu-toggler"
                                 [icon]="isSubMenuOpen(applicationConfig) ? chevronUp: chevronDown"
                                 (click)="toggleSubMenu(applicationConfig)"></fa-icon>

                    </div>

                    <tab-navigation *ngIf="isSubMenuOpen(applicationConfig)"
                                    [tabs]="appRootService?.currentAppConfig?.tabs"
                                    (onChangeTab)="closeMenu()"
                                    display="rows">
                    </tab-navigation>
                </ng-container>
            </div>

        </dropdown>
    `,
    styleUrls: ['./nav.scss']
})
export class AppNavComponent implements OnInit {

    public togglerIcon: IconDefinition = faBars;
    public toggled: boolean;

    public readonly chevronUp: IconDefinition = faChevronUp;
    public readonly chevronDown: IconDefinition = faChevronDown;

    public iconHome: IconDefinition = faHome;
    public homeName: string = Yii.t('wui-shared-js', 'Accueil');

    public appConfigurationsValues: IGlobalAppConfig[];

    @ViewChild('dropdown')
    public dropdown: DropdownComponent;
    private readonly openedMenu: Map<string, boolean> = new Map();



    constructor(
        public appRootService: AppRootService,
        private readonly configurationResourceService: ConfigurationResourceService,
        private readonly permissionService: PermissionResourceService,
    ) {
    }

    public ngOnInit(): void {

        this.configurationResourceService.get(['wui', 'config', 'home', 'home.json'], CONFIG_HOME)
            .subscribe((config: IHomeConfig): void => {
                this.homeName = config.globalName;
            });

    }

    public setMenu(): void {
        this.appConfigurationsValues = [];
        (wenji.appList || [])
            .map((code: string): string => code.replace(/^app_/, ''))
            .filter((code: string): boolean => code !== 'home')
            .forEach(
                (code: string): void => {
                    const specialApp: ICheckRightUse = this.appRootService.appMenuPermission.find((app: ICheckRightUse): boolean => app.code === code);
                    if (specialApp) {
                        this.permissionService.hasPermission(specialApp.permission)
                            .subscribe({
                                next: (isPermitted: boolean): void => {
                                    if (isPermitted) {
                                        this.appRootService.appConfigurations.set(code, this.appRootService.getAppConfig(code));
                                        this.appConfigurationsValues.push(this.appRootService.getAppConfig(code));
                                    }
                                }
                            })
                            .unsubscribe();
                    } else {
                        this.appRootService.appConfigurations.set(code, this.appRootService.getAppConfig(code));
                        this.appConfigurationsValues.push(this.appRootService.getAppConfig(code));
                    }

                }
            );
    }

    public closeMenu(): void {
        this.dropdown.toggle();
    }

    public hasSubMenu(applicationConfig: IGlobalAppConfig): boolean {
        return Boolean(applicationConfig && applicationConfig.tabs && applicationConfig.tabs.length);
    }

    public toggleSubMenu(applicationConfig: IGlobalAppConfig) {
        const opened = this.isSubMenuOpen(applicationConfig);

        this.openedMenu.set(applicationConfig.code, !opened);
    }

    public isSubMenuOpen(applicationConfig: IGlobalAppConfig) {
        let opened = this.openedMenu.get(applicationConfig.code);

        if (opened === undefined) {
            opened = Boolean(
                applicationConfig.tabs
                && applicationConfig.tabs.length
                && this.appRootService.currentAppConfig.code === applicationConfig.code
            );
        }

        return opened;
    }

    public findIcon(iconName: IconName): IconDefinition {
        return findIconDefinition({iconName, prefix: "fas"});
    }
}
